import React, { useRef, useState , useEffect,useMemo} from 'react';
import moment from 'moment';
import {
  StructuredGenerate,
  DynamicDropDownInput,
  DynamicNumericInput,
  DynamicDateInput,
  DynamicTextInput,
  DynamicCheckBoxInput,
  DynamicHiddenInput,
  DynamicButtonInput
} from '../software-dynamic-version-2/mainSection-multiple-inputs-v-2';

const FullPropertyAdd = (props) => {
  
  let { DynamicDropDownInput: DropdownComponent, DynamicNumericInput: NumberComponent, DynamicDateInput: DateComponent , DynamicTextInput: TextComponent ,DynamicCheckBoxInput:CheckBoxComponent , DynamicHiddenInput : HiddenComponent , DynamicButtonInput:ButtonComponent} = { DynamicDropDownInput, DynamicNumericInput, DynamicDateInput ,DynamicTextInput , DynamicCheckBoxInput,DynamicHiddenInput,DynamicButtonInput};
// MainTransferID	
// UserID	
// TransferDate	
// FromShopID	
// ToShopID
  
const [inputProps, setInputProps] = useState({
  FullPropertyID: { name: 'FullPropertyID', value: props.FullPropertyID || '', enabled: false },
  CompanyID: { name: 'CompanyID', value: props.CompanyID || '' },

  PropertyName:{
    name:{id:'PropertyID',value:'PropertyName'},
    caption: 'Select Property Name',
    value: {id: props.PropertyID || 'undefined' ,value:props.PropertyName || ''},
    dataSource: {type:'Route',route:'Property'},
    addNew:{Route:'Property',Security:'Property'},
    // enabled:!handleInputEnabled
    // isControlBlur:false
  },

  PropertyOwnerName:{
    name:{id:'PropertyOwnerID',value:'PropertyOwnerName'},
    caption: 'Select Property Owner',
    value: {id: props.PropertyOwnerID || 'undefined' ,value:props.PropertyOwnerName || ''},
    dataSource: {type:'Route',route:'PropertyOwner'},
    addNew:{Route:'PropertyOwner',Security:'Property Owner'},
    // enabled:!handleInputEnabled
    // isControlBlur:false
  },

  // BuildingID: { name: 'BuildingID', value: props.BuildingID || '' },
  
  BuildingNo:{
    name:{id:'BuildingID',value:'BuildingNo'},
    caption: 'Select Building',
    value: {id: props.BuildingID || 'undefined' ,value:props.BuildingNo || ''},
    dataSource: {type:'Route',route:'Building'},
    addNew:{Route:'Building',Security:'Building'},
    // enabled:!handleInputEnabled
    // isControlBlur:false
  },


  PropertyLocationID: {
    name: { id: 'PropertyLocationID', value: 'PropertyLocation' },
    caption: 'Select Property Location',
    value: { id: props.PropertyLocationID || 'undefined', value: props.PropertyLocation || '' },
    dataSource: { type: 'Route', route: 'PropertyLocation' },
    addNew: { Route: 'PropertyLocation', Security: 'Property Location' },
},

PropertyFloorID: {
    name: { id: 'PropertyFloorID', value: 'PropertyFloor' },
    caption: 'Select Property Floor',
    value: { id: props.PropertyFloorID || 'undefined', value: props.PropertyFloor || '' },
    dataSource: { type: 'Route', route: 'PropertyFloor' },
    addNew: { Route: 'PropertyFloor', Security: 'Property Floor' },
},

PropertyUnitTypeID: {
    name: { id: 'PropertyUnitTypeID', value: 'PropertyUnitType' },
    caption: 'Select Property Unit Type',
    value: { id: props.PropertyUnitTypeID || 'undefined', value: props.PropertyUnitType || '' },
    dataSource: { type: 'Route', route: 'PropertyUnitType' },
    addNew: { Route: 'PropertyUnitType', Security: 'Property Unit Type' },
},

  PropertyUnitNo: { name: 'PropertyUnitNo', value: props.PropertyUnitNo || '' },
  IsPropertyThirdParty: { name: 'IsPropertyThirdParty', caption:'IS THIRD PARTY' ,value: props.IsPropertyThirdParty == "Yes" ? true : false },
  PropertyCoveredArea: { name: 'PropertyCoveredArea', value: props.PropertyCoveredArea || '' },
  PropertyDEWA: { name: 'PropertyDEWA', value: props.PropertyDEWA || '' },
  PropertyPlotNo: { name: 'PropertyPlotNo', value: props.PropertyPlotNo || '' }
});
// EXTRA CODE START

// EXTRA CODE END

const handleInputCreated = async (e, name) => {
  console.log(e);
    console.log(`Input ${name} changed to ${e}`);
  };
const handleInputFocus = async (e, name) => {
  
    console.log(e);
    console.log(`Input ${name} focus to ${e}`);
  };
const handleInputChange = async (value, name) => {
  
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
const handleInputBlur = async  (value, name) => {
    console.log(value);
    console.log(`Input ${name} focus to ${value}`);
  };
 
  let inputsList = [
    {Input: DropdownComponent,Props: {...inputProps.PropertyName, setInputProps }, ColumnSize: 6},
    { Input: HiddenComponent, Props: { ...inputProps.CompanyID, setInputProps }, ColumnSize: 0 },
    {Input: DropdownComponent,Props: {...inputProps.PropertyOwnerName, setInputProps }, ColumnSize: 6},
    
    // { Input: TextComponent, Props: { ...inputProps.BuildingID, setInputProps }, ColumnSize: 6 },
    {Input: DropdownComponent,Props: {...inputProps.BuildingNo, setInputProps }, ColumnSize: 6},

    { Input: DropdownComponent, Props: { ...inputProps.PropertyLocationID, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.PropertyFloorID, setInputProps }, ColumnSize: 6 },
    { Input: DropdownComponent, Props: { ...inputProps.PropertyUnitTypeID, setInputProps }, ColumnSize: 6 },


    { Input: TextComponent, Props: { ...inputProps.PropertyUnitNo, setInputProps }, ColumnSize: 6 },
    { Input: CheckBoxComponent, Props: { ...inputProps.IsPropertyThirdParty, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.PropertyCoveredArea, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.PropertyDEWA, setInputProps }, ColumnSize: 6 },
    { Input: TextComponent, Props: { ...inputProps.PropertyPlotNo, setInputProps }, ColumnSize: 6 }
];
  return (
    <div onKeyDown={(e)=>e.stopPropagation()}>
      {/* <FirstGridComponent/> */}
      <StructuredGenerate   mainProps={props} title={`Full Property ${props.isAdd == true ? `Add` : `Edit`}`} Inputs={inputsList}/>
      {/* <pre>{JSON.stringify(inputProps, null, 2)}</pre> This is to display current state for debugging */}
      </div>
  );
}; 

export default FullPropertyAdd;
